import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  changeDisabled (e) {
    e.target.disabled = true
  }
}
